import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { dayjs } from '@sc/utils';

export class AgendaEventRecurrenceValidators {
  public static endDateCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const hasRecurrence = !!control.get('isRecurrent')?.value;
      const hasEnd = control.get('recurrence')?.get('hasEnd')?.value === 'true';
      const endDate = control.get('recurrence')?.get('endDate')?.value;

      if (hasRecurrence && hasEnd && !dayjs(endDate).isValid()) {
        return {
          no_recurrence_end_date: true,
        };
      }

      return null;
    };
  }
}
